module.exports = __webpack_public_path__ + "static_pc/img/2.f13e703d.png";